var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "weight-modal-overlay"
  }, [_c('div', {
    staticClass: "weight-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(" Enter your " + _vm._s(_vm.submissionType === "pre_weight" ? "pre" : "post") + " weight ")]), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "novalidate": "",
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _c('div', {
    staticClass: "weight-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.weightValue,
      expression: "weightValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "weight-input",
    class: {
      error: _vm.errors.weight
    },
    attrs: {
      "id": "weight-input",
      "type": "number",
      "placeholder": "Enter weight",
      "step": "0.1",
      "min": "1",
      "max": "300",
      "required": ""
    },
    domProps: {
      "value": _vm.weightValue
    },
    on: {
      "wheel": function ($event) {
        return $event.target.blur();
      },
      "blur": [_vm.validateWeight, function ($event) {
        return _vm.$forceUpdate();
      }],
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.weightValue = _vm._n($event.target.value);
      }, _vm.clearWeightError]
    }
  }), _c('span', {
    staticClass: "weight-unit"
  }, [_vm._v("kg")])]), _vm.errors.weight ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.weight) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.videoLink,
      expression: "videoLink"
    }],
    staticClass: "video-input",
    class: {
      error: _vm.errors.videoLink
    },
    attrs: {
      "id": "video-input",
      "type": "url",
      "placeholder": "https://www.youtube.com/",
      "required": ""
    },
    domProps: {
      "value": _vm.videoLink
    },
    on: {
      "blur": _vm.validateVideoLink,
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.videoLink = $event.target.value;
      }, _vm.clearVideoLinkError]
    }
  }), _vm.errors.videoLink ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.videoLink) + " ")]) : _vm._e()]), _vm._l(_vm.additionalFields, function (field) {
    return _c('div', {
      key: field.key,
      staticClass: "form-group",
      class: {
        'has-instruction': field.instruction
      }
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": field.key
      }
    }, [_vm._v(_vm._s(field.placeholder)), field.required !== false ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]) : _vm._e()]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.additionalFieldValues[field.key],
        expression: "additionalFieldValues[field.key]"
      }],
      staticClass: "video-input",
      class: {
        error: _vm.additionalFieldErrors[field.key]
      },
      attrs: {
        "id": field.key,
        "type": "text",
        "placeholder": field.placeholder,
        "maxlength": "255",
        "required": field.required !== false
      },
      domProps: {
        "value": _vm.additionalFieldValues[field.key]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.additionalFieldValues, field.key, $event.target.value);
        }, function ($event) {
          _vm.additionalFieldErrors[field.key] = '';
        }],
        "blur": function ($event) {
          _vm.additionalFieldErrors[field.key] = _vm.additionalFieldError(field);
        }
      }
    }), field.instruction ? _c('div', {
      staticClass: "field-instruction"
    }, [_vm._v(" " + _vm._s(field.instruction) + " ")]) : _vm._e(), _vm.additionalFieldErrors[field.key] ? _c('div', {
      staticClass: "error-message"
    }, [_vm._v(" " + _vm._s(_vm.additionalFieldErrors[field.key]) + " ")]) : _vm._e()]);
  }), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "submit-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitting
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmitting ? "Submitting..." : "Submit") + " ")])])], 2)])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "weight-input"
    }
  }, [_vm._v("Weight"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "video-input"
    }
  }, [_vm._v("Video Link"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }